import { render, staticRenderFns } from "./ArticleTemplate.vue?vue&type=template&id=9aa0e9b0&"
import script from "./ArticleTemplate.vue?vue&type=script&lang=js&"
export * from "./ArticleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTemplate.vue?vue&type=style&index=0&id=9aa0e9b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports